import React, { useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { observable, runInAction, action } from 'mobx';
import { update } from 'serializr';

import { Campaign } from '@vromo/models';

import Title from '@vromo/ui/components/Title';
import Modal, { ModalHeader, ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import Button from '@vromo/ui/components/Button';
import Input from '@vromo/ui/components/Input';
import { qaLabelCampaigns } from './../../../../common-qa-labels/campaigns';

export default observer(function NewCampaign({ isOpen, create, onCancel }) {
    const store = useLocalObservable(() => ({
        campaign: new Campaign(),
        updateName(e) {
            store.campaign.name = e.target.value;
        }
    }));

    useEffect(
        action(() => {
            update(store.campaign, {
                name: '',
                theme: {},
                promotion: {},
                link: {},
                widgets: []
            });
        }),
        []
    );

    if (!store.campaign) return null;

    return (
        <Modal isOpen={isOpen} onRequestClose={onCancel}>
            <ModalHeader>
                <Title>New Campaign</Title>
            </ModalHeader>

            <ModalContent>
                <label style={{ width: '100%' }}>
                    Name
                    <Input
                        data-testid={qaLabelCampaigns.campaignNameInput}
                        type="text"
                        value={store.campaign.name || ''}
                        onChange={store.updateName}
                    />
                </label>
            </ModalContent>

            <ModalActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button
                    data-test-id={qaLabelCampaigns.addCampaignModalSaveButton}
                    data-testid={qaLabelCampaigns.addCampaignModalSaveButton}
                    onClick={() => create(store.campaign)}>
                    Save
                </Button>
            </ModalActions>
        </Modal>
    );
});
